import { first } from 'rxjs/operators';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, Input, OnInit } from '@angular/core';
import { AlertService } from '@app/_services';
import { LazyLoadEvent, MessageService, ConfirmationService } from 'primeng/api';
import { PersonEmailService } from '../person-email.service';
import { PersonEmail } from '../person-email';
import { PersonEmailComponent } from '../person-email/person-email.component';
import { PersonService } from '@app/_components/person';

@Component({
    selector: 'app-person-email-list',
    templateUrl: './person-email-list.component.html',
    styleUrls: ['./person-email-list.component.css'],
    providers: [MessageService, ConfirmationService, { provide: MAT_DIALOG_DATA, useValue: {} }],
    // make column heading sticky
    styles: [`
        :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
            position: -webkit-sticky;
            position: sticky;
            top: 0px;
        }

        @media screen and (max-width: 64em) {
            :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
                top: 99px;
            }
        }
`],
    standalone: false
})
export class PersonEmailListComponent implements OnInit {
	constructor(
		private personService: PersonService,
		private personEmailService: PersonEmailService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private dialog: MatDialog,
	) {
		this.statuses = personEmailService.statuses
		this.emailTypes =  this.personService.emailTypes;
	}



	// data
	@Input() personId: any;
	personEmails: any;
	emailTypes: any;
	personEmail: PersonEmail;

	// paging
	first = 0;
	rows = 50;

	// list
	datasource: any;

	recordTotal: number;
	lazyLoadEvent: LazyLoadEvent;
	loading = true;
	multiSortMeta = [];

	// forms
	formLoading = false;

	statuses: any;

	columns: any[] = [
		{ field: 'personEmailId', header: 'Id', width: 'auto' },
		{ field: 'type', header: 'Type', width: 'auto' },
		{ field: 'emailAdr', header: 'Email Address', width: 'auto' },
		/*{ field: 'personId', header: 'PersonId', width: 'auto' },*/
	];

	ngOnInit(): void {
		try {
			// default sort of list
			this.multiSortMeta = [];
			this.multiSortMeta.push({ field: 'createDate', order: 0 });
		}
		catch (error) {
			console.log('Error: ' + error);
		}
	}

	/*********
	 * Delete Button
	 *
	 */
	onRowDelete(event: any) {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + event.personEmailId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete(event);
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}


	/*********
	 * Lazy Load All Data
	 *
	 */
	loadLazy(event: LazyLoadEvent) {
		try {
			this.loading = true;
			this.lazyLoadEvent = event;

			console.log(
				' event.first:' + event.first
				+ '  |  event.rows:' + event.rows
				+ '  |  event.sortField:' + event.sortField
				+ '  |  event.sortOrder:' + event.sortOrder
				+ '  |  event.multiSortMeta:' + JSON.stringify(event.multiSortMeta)
				+ '  |  event.globalFilter:' + event.globalFilter
				+ '  |  event.filters:' + JSON.stringify(event.filters)
			);

			/*
			*
			* Default Sort
			*/
			// https://stackoverflow.com/questions/679915/how-do-i-personEmail-for-an-empty-javascript-object
			// if we are NOT filtering and we are NOT sorting, apply a default sort
			if (Object.keys(event.filters).length === 0 && !event.multiSortMeta) {
				event.multiSortMeta = [];
				event.multiSortMeta.push({ field: 'createDate', order: -1 });
			}
			
			if(this.personId)
			{
				// show only activities that are assigned to this activityProviderId
				let personIdFilter = { 'personId': { 'value': this.personId, 'matchMode': 'in' } };
				Object.assign(event.filters, personIdFilter);
			}

			const pageNumber = Math.round(event.first / event.rows);
			this.personEmailService.findByFilter(
				pageNumber, event.rows,
				event.sortField,
				event.sortOrder,
				event.multiSortMeta,
				event.globalFilter,
				event.filters).pipe(first()).subscribe(

					(res: any) => {
						this.datasource = res.data;
						this.recordTotal = res.page.recordTotal;
						this.personEmails = res.data.emails;
						console.log(JSON.stringify(res.page));
					},
					(err: any) => {
						console.log('reviews list error!: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.loading = false; }
				);

			if (this.datasource) {
				this.personEmails = this.datasource.slice(event.first, (event.first + event.rows));
			}
		} catch (error) {
			console.log('loadLazy(' + event + ')' + error);
		}
	}

	getStatus() {
		return
	}

	/*********
	 * onRowSelect()
	 * Used to handle row click (to edit, link, etc)
	 */
	onRowSelect(event: any) {
		console.log('onRowSelect: ' + JSON.stringify(event));
		this.onOpenFormEdit(event.data);
	}

	// handled in rate-bucket-form
	formAdd() { }


	/*********
	 * formUpdate()
	 * Used for row editing
	 */
	formUpdate(personEmail: PersonEmail) {
		try {
			this.formLoading = true;
			this.personEmailService.update(personEmail)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Update SUCCESS: ' + JSON.stringify(res));
						this.personEmails.map((personEmail, i) => {
							if (personEmail.personEmailId === res.data.personEmail.personEmailId) {
								this.personEmails[i] = res.data.personEmail;
							}
						});
						// this.alertService.success(res, true);
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
					},
					(err: any) => {
						console.log('Rate-Bucket-Update FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: JSON.stringify(err), life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
	 * formDelete()
	 * Used for row editing
	 */
	formDelete(personEmail: any) {
		try {
			// stop here if form is invalid
			console.log('Delete Submitted: ' + JSON.stringify(personEmail));

			this.formLoading = true;
			this.personEmailService.delete(personEmail.personEmailId)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Delete SUCCESS: ' + JSON.stringify(res));
						this.personEmails.splice(this.personEmails.indexOf(personEmail), 1);
						this.recordTotal = this.personEmails.length;
						this.messageService.add({ severity: 'success', summary: 'Successful', detail: 'PersonEmail ' + personEmail.personEmailId + ' Deleted', life: 3000 });
					},
					(err: any) => {
						console.log('Rate-Bucket-Delete  FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: 'Delete Failed', detail: 'PersonEmail ' + personEmail.personEmailId + ' could not be deleted.  Be sure there are no assigned properties to this bucket.', life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
		 * Add New Button
		 *
		 */
	onOpenFormAdd() {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			title: 'Add Email',
			personId: this.personId
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(PersonEmailComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
		dialogRef.componentInstance.doAdd.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.addPersonEmailCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/*********
		* Edit Button
		*
		*/
	onOpenFormEdit(personEmail: PersonEmail) {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			personEmail: personEmail,
			personId: this.personId,
			title: 'Edit Email'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(PersonEmailComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doUpdate' in the element to handle updating the list
		dialogRef.componentInstance.doUpdate.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.updatePersonEmailCB(data);

				// close the dialogBox
				dialogRef.close();
			});

		dialogRef.componentInstance.doDelete.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.deletePersonEmailCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/**
	   *
	   * Dialog from Form Callbacks
	   * To edit the list show add/edit/delete in real time from the popup form
	   *
	   */
	addPersonEmailCB(personEmail: PersonEmail) {
		console.log('Adding PersonEmail: ' + JSON.stringify(personEmail));
		// if we don't have a personEmails array yet...
		if (!this.personEmails) {
			this.personEmails = [];
		}
		// unshift adds to the front of the array (), push adds to the back
		this.personEmails.unshift(personEmail);

		// no idea what this is but it is required to update the array
		this.personEmails = [...this.personEmails];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'PersonEmail ' + personEmail.personEmailId + ' Added', life: 3000 });
	}

	updatePersonEmailCB(personEmail: PersonEmail) {
		console.log('Updating PersonEmail: ' + JSON.stringify(personEmail));
		let itemIndex = this.personEmails.findIndex((item: any) => item.personEmailId === personEmail.personEmailId);
		this.personEmails[itemIndex] = personEmail;

		// no idea what this is but it is required to update the array
		this.personEmails = [...this.personEmails];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'PersonEmail ' + personEmail.personEmailId + ' Updated', life: 3000 });
	}

	deletePersonEmailCB(personEmail: PersonEmail) {
		console.log('Removing PersonEmail: ' + personEmail);
		this.personEmails.splice(this.personEmails.indexOf(personEmail), 1);
		this.recordTotal = this.personEmails.length;

		// no idea what this is but it is required to update the array
		this.personEmails = [...this.personEmails];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'PersonEmail ' + personEmail.personEmailId + ' Deleted', life: 3000 });
	}

	/**********
	 *
	 * PAGINATOR FUNCTIONS
	 */
	next() { this.first = this.first + this.rows; }
	prev() { this.first = this.first - this.rows; }
	reset() { this.first = 0; }
	isLastPage(): boolean { return this.personEmails ? this.first === (this.personEmails.length - this.rows) : true; }
	isFirstPage(): boolean { return this.personEmails ? this.first === 0 : true; }

	get Statuses() {
		return this.statuses;
	}

	getStatusName(personEmail: any) {
		if (personEmail?.status) {
			const status = this.statuses.find((e: any) => e.value == personEmail.status);
			return status.name;
		}
		else {
			return '';
		}
	}
	
	getEmailType(personEmail: any) {
		if (personEmail?.type) {
			const status = this.emailTypes.find((e: any) => e.value == personEmail.type);
			return status.name;
		}
		else {
			return '';
		}
	}
	
	reloadPage() {
		window.location.reload();
	}
}
